import columns from "./columns";
import formFields from "./formFields";
import previewFields from "./previewFields";

export default {
    entityName: "orders",
    pageTitle: "Orders",
    columns,
    formFields,
    previewFields,
    tableOptions: {
        hideCreate: true,
    },
    formOptions: {},
    previewOptions: {
        fetchEntity: true,
    },
};
